export default "__VITE_ASSET__CHENfg6y__"